import _ from "lodash";
import { makeAutoObservable } from "mobx";
import tinyColor from "tinycolor2";

class ColorModel {
  colorMap = {};
  constructor({ appStore }) {
    try {
      appStore.getPref("pm.waveColors").then((colorMap) => {
        if (colorMap) {
          const entries = Object.entries(colorMap);
          const converted = entries
            .filter((entry) => entry[1])
            .map(([key, color]) => [key, limitGamut(color)]);
          this.colorMap = Object.fromEntries(converted);
        }
      });
    } catch (e) {
      console.warn("Error getting pm waveColors map", e);
    }
    makeAutoObservable(this);
    this.appStore = appStore;
  }
  getColor(key) {
    return this.colorMap[key]?.toHexString();
  }
  setColor(key, color) {
    if (!color) {
      if (!this.colorMap[key]) return;
      else delete this.colorMap[key];
    } else {
      const _color = color && limitGamut(color);
      this.colorMap[key] = _color;
    }
    this.save();
  }
  get patientColors() {
    return this.colorMap || {};
  }
  get colors() {
    return _.uniq(
      [...Object.values(this.colorMap), ...themeColors]
        .filter(Boolean)
        .map((c) => c.toHexString()),
    );
  }
  prune({ patients }) {
    const storedAsmpids = Object.entries(this.colorMap).reduce(
      (storedAsmpids, [asmpid, color]) => {
        if (color) return [...storedAsmpids, asmpid];
        return storedAsmpids;
      },
      [],
    );
    const obsolteIds = _.difference(
      storedAsmpids,
      patients.map((p) => p.asmpid),
    );
    obsolteIds.forEach((asmpid) => {
      this.colorMap[asmpid] = undefined;
    });
    if (obsolteIds.length) this.save();
  }
  save() {
    const entries = Object.entries(this.colorMap).map(([id, color]) => [
      id,
      color?.toHexString(),
    ]);
    let waveColors;
    if (entries.length) waveColors = Object.fromEntries(entries);
    this.appStore.setPref("pm.waveColors", waveColors);
  }
}

export default ColorModel;

export function limitGamut(color) {
  let newColor = tinyColor(color);
  const black = tinyColor("#000");
  while (
    tinyColor.isReadable(newColor, black, { level: "AA", size: "small" }) ===
    false
  ) {
    newColor = newColor.lighten(1);
  }
  return newColor;
}

export const themeColors = [
  "rgb(255, 128, 255)",
  "rgb(152, 84, 212)",
  "rgb(176, 176, 176)",
  "rgb(0, 192, 192)",
  "rgb(46, 174, 42)",
  "rgb(11, 255, 0)",
  "rgb(255, 230, 100)",
  "rgb(255, 136, 0)",
  "rgb(232, 30, 30)",
  "rgb(184, 92, 0)",
].map((color) => limitGamut(color));
